function normalizedValues(values) {
  return Array.isArray(values) ? values.map(String) : [];
}

function sameValues(left, right) {
  return left.length === right.length && left.every((value, index) => value === right[index]);
}

export function effectiveProductOptions(products, productGroupMode, productGroupIds) {
  const catalog = Array.isArray(products) ? products : [];
  const selectedGroups = new Set(normalizedValues(productGroupIds));

  if (productGroupMode === 'all' || selectedGroups.size === 0) {
    return catalog;
  }

  if (productGroupMode === 'include') {
    return catalog.filter(product => selectedGroups.has(String(product.groupId)));
  }

  if (productGroupMode === 'exclude') {
    return catalog.filter(product => !selectedGroups.has(String(product.groupId)));
  }

  return catalog;
}

/**
 * Canonicalize the coupled product dimensions against stable catalogue IDs.
 * The group and product filters remain independent API dimensions; this only
 * prevents a product that is hidden by the current group scope from remaining
 * active in state, chips, or a serialized report URL.
 */
export function reconcileProductCatalogFilters(filters, products, productGroups) {
  const availableGroupIds = new Set((Array.isArray(productGroups) ? productGroups : [])
    .map(group => String(group.value)));
  const currentGroupIds = normalizedValues(filters.productGroupIds);
  const productGroupIds = filters.productGroupMode === 'all'
    ? []
    : currentGroupIds.filter(groupId => availableGroupIds.has(groupId));
  const effectiveProducts = effectiveProductOptions(
    products,
    filters.productGroupMode,
    productGroupIds
  );
  const availableProductIds = new Set(effectiveProducts.map(product => String(product.value)));
  const currentProductIds = normalizedValues(filters.productIds);
  const productIds = filters.productMode === 'all'
    ? []
    : currentProductIds.filter(productId => availableProductIds.has(productId));

  if (sameValues(currentGroupIds, productGroupIds) && sameValues(currentProductIds, productIds)) {
    return filters;
  }

  return { ...filters, productGroupIds, productIds };
}
